<template>
  <div>
    <window title="Vue notifications <a href='https://github.com/se-panfilov/vue-notifications'
                                        target='_blank'>(more info)">
      <h3 class="title">Try it live</h3>
      <p class="sub-title" style="padding-bottom: 20px">We have 4 predefined types of messages:
        error, success, warn and info, but you can specify your owns</p>
      <div class="columns">
        <div class="column is-one-quarter">
          <ul class="lbuttons">
            <li>
              <button type="button" class="button is-success" @click="showSuccessMsg()">
                Success
              </button>
            </li>
            <li>
              <button type="button" class="button is-info" @click="showInfoMsg()">
                Info
              </button>
            </li>
            <li>
              <button type="button" class="button is-warning" @click="showWarnMsg()">
                Warning
              </button>
            </li>
            <li>
              <button type="button" class="button is-danger" @click="showErrorMsg()">
                Error
              </button>
            </li>
          </ul>
        </div>
        <div class="column is-one-quarter">
          <ul>
            <li v-for="(value, key) in libs" v-bind:key="key" @change="setCurrentLib(key)">
                <b-radio :checked="currentLib === value" :value="key" name="lib" />
                {{value}}
            </li>
          </ul>
        </div>
      </div>
    </window>
  </div>
</template>

<script>
import Vue from 'vue';
import VueNotifications from 'vue-notifications';

// Third-party UI libs
import VueEasyToast from 'vue-easy-toast'; // https://github.com/noru/vue-easy-toast
import miniToastr from 'mini-toastr'; // https://github.com/se-panfilov/mini-toastr
import VueToasted from 'vue-toasted'; // https://github.com/shakee93/vue-toasted

// iziToast
import iziToast from 'izitoast'; // https://github.com/dolce/iziToast
import 'izitoast/dist/css/iziToast.min.css';
// end iziToast
// noty
import Noty from 'noty'; // https://github.com/needim/noty
import 'noty/lib/noty.css';
// end noty
// sweetalert
import swal from 'sweetalert';
// https://github.com/t4t5/sweetalert
Vue.config.productionTip = false;
miniToastr.init();
const UI_LIBS = {
  miniToastr: 'miniToastr',
  VueToasted: 'VueToasted',
  VueEasyToast: 'VueEasyToast',
  iziToast: 'iziToast',
  Noty: 'Noty',
  swal: 'swal',
};
const TOASTS = {
  [UI_LIBS.miniToastr]({
    title, message, type, timeout, cb,
  }) {
    return miniToastr[type](message, title, timeout, cb);
  },
  [UI_LIBS.VueToasted]({ message, type, timeout }) {
    let msgType = type;
    if (type === VueNotifications.types.warn) msgType = 'show';
    return Vue.toasted[msgType](message, { duration: timeout });
  },
  [UI_LIBS.VueEasyToast]({ message, type, timeout }) {
    let className = 'et-info';
    if (type === VueNotifications.types.warn) className = 'et-warn';
    else if (type === VueNotifications.types.error) className = 'et-alert';
    return Vue.toast(message, { duration: timeout, className });
  },
  [UI_LIBS.iziToast]({
    title, message, type, timeout,
  }) {
    let msgType = type;
    if (type === VueNotifications.types.warn) msgType = 'warning';
    return iziToast[msgType]({ title, message, timeout });
  },
  [UI_LIBS.Noty]({ message, type, timeout }) {
    let msgType = type;
    if (type === VueNotifications.types.warn) msgType = 'warning';
    return new Noty({ text: message, timeout, msgType }).show();
  },
  [UI_LIBS.swal]({ title, message, type }) {
    let msgType = type;
    if (type === VueNotifications.types.warn) msgType = 'warning';
    return swal(title, message, msgType);
  },
};

Vue.use(VueEasyToast);
Vue.use(VueToasted);


function toast({
  title, message, type, timeout, cb, debugMsg,
}) {
  if (debugMsg) console[type](debugMsg);
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};
Vue.use(VueNotifications, options);
export default {
  name: 'showcase',
  data() {
    return {
      libs: UI_LIBS,
      currentLib: UI_LIBS.miniToastr,
      checked: '',
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success, // or just 'success' or any other string
      title: 'Hello there',
      message: 'That\'s the success!',
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you',
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning',
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error',
    },
  },
  methods: {
    setCurrentLib(libKey) {
      this.currentLib = libKey;
      this.checked = libKey;
      const optionsX = {
        success: TOASTS[this.currentLib],
        error: TOASTS[this.currentLib],
        info: TOASTS[this.currentLib],
        warn: TOASTS[this.currentLib],
      };
      // Changing options dynamically
      VueNotifications.setPluginOptions(optionsX);
    },
  },
};
</script>

<style scoped>
ul.lbuttons li {
  padding-bottom: 10px;
}
</style>
